import React, { useEffect, useState } from "react";
import "./navbar.css";
import { useNavigate } from "react-router-dom";
import { API } from "../api";

const Navbar = () => {
  const [logo, setLogo] = useState(false);
  const [headerData, setHeaderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch header data from API
  const fetchHeaderData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/header`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch header data");
      }

      const data = await response.json();

      if (data.isSuccess && data.payload.data && data.payload.data.length > 0) {
        setHeaderData(data.payload.data[0]);
      } else {
        throw new Error("No header data found");
      }
    } catch (error) {
      console.error("Error fetching header data:", error);
      // Fallback to default data
      setHeaderData({
        route: [
          {
            name: "About Us",
            path: "/about-us",
            option: [],
          },
          {
            name: "Disclaimer",
            path: "/disclaimer",
            option: [],
          },
          {
            name: "Our Products",
            path: "",
            option: [
              {
                link: "/multimanager-portfolio",
                name: "1UP",
              },
              {
                link: "/proud-portfolio",
                name: "Proud Portfolio",
              },
              {
                link: "/opportunities-portfolio",
                name: "COP",
              },
            ],
          },
        ],
        buttonName: "Contact Us",
        buttonLink: "/contact-us",
        image: {
          path: "/uploads/images/images-1762233738412.png",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHeaderData();

    const nav = document.querySelector(".navbarMain");
    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        setLogo(true);
      } else {
        setLogo(false);
      }
    });

    window.addEventListener("scroll", () => {
      if (lastScrollY < window.scrollY) {
        nav.classList.add("navbarMain--hidden");
      } else {
        nav.classList.remove("navbarMain--hidden");
      }
      lastScrollY = window.scrollY;
    });
  }, []);

  // Helper function to get media URL
  const getMediaUrl = (mediaObject) => {
    if (!mediaObject) return require("../../Images/navlogo.png");

    if (mediaObject.path) {
      if (mediaObject.path.startsWith("http")) {
        return mediaObject.path;
      } else {
        return `${API}${mediaObject.path}`;
      }
    }

    if (mediaObject.id) {
      return `${API}/api/media/${mediaObject.id}`;
    }

    return require("../../Images/navlogo.png");
  };

  const phoneNumber = "9099302000";
  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, "_blank");
  };

  // Find specific routes
  const aboutUsRoute = headerData?.route?.find(
    (item) => item.name === "About Us"
  );
  const disclaimerRoute = headerData?.route?.find(
    (item) => item.name === "Disclaimer"
  );

  console.log("headerData:", headerData);
  const ourProductsRoute = headerData?.route?.find(
    (item) => item.name === "Our Products"
  );

  if (loading) {
    return (
      <div className="navbarMain">
        <div className="h-100">
          <div className="col-11 m-auto d-flex align-items-center justify-content-between h-100">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="navbarMain">
      <div className="h-100">
        <div className="col-11 m-auto d-flex align-items-center justify-content-between h-100">
          <div className="position-relative">
            <div
              className="py-2"
              onClick={() => navigate("/")}
              style={!logo ? { height: "70px" } : { height: "70px" }}
            >
              <img
                src={getMediaUrl(headerData?.image)}
                style={{ height: "100%" }}
                alt="Logo"
                loading="lazy"
                onError={(e) => {
                  e.target.src = require("../../Images/navlogo.png");
                }}
              />
            </div>
          </div>

          <div className="pcNav">
            <div className="d-flex gap-4 align-items-center">
              {/* About Us Link */}
              {aboutUsRoute && (
                <p
                  className="fw-semibold"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(aboutUsRoute.path)}
                >
                  {aboutUsRoute.name}
                </p>
              )}
              {disclaimerRoute && (
                <p
                  className="fw-semibold"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(disclaimerRoute.path)}
                >
                  {disclaimerRoute.name}
                </p>
              )}

              {/* Dropdown for Our Products - PC Navigation */}
              {ourProductsRoute &&
                ourProductsRoute.option &&
                ourProductsRoute.option.length > 0 && (
                  <div className="dropdown">
                    <p
                      className="fw-semibold dropdown-toggle"
                      style={{ cursor: "pointer" }}
                      type="button"
                      id="ourProductsDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {ourProductsRoute.name}
                    </p>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="ourProductsDropdown"
                    >
                      {ourProductsRoute.option.map((product, index) => (
                        <li key={index}>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(product.link.replace("#", ""));
                            }}
                          >
                            {product.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
            </div>
          </div>

          <div className="d-flex gap-3 align-items-center">
            <div className="pcNav d-flex gap-3 align-items-center">
              <button
                className="buttonEffect"
                style={{ backgroundColor: "#000" }} // Optional: distinct style
                onClick={() =>
                  window.open("https://ladderup.investwell.app", "_blank")
                }
              >
                Analyse Your Portfolio
              </button>
              {headerData?.buttonName && (
                <button
                  className="buttonEffect"
                  onClick={() =>
                    navigate(headerData.buttonLink.replace("#", ""))
                  }
                >
                  {headerData.buttonName}
                </button>
              )}
            </div>
            <div className="mobileNav">
              <p
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
                aria-controls="offcanvasExample"
              >
                <i className="bi bi-list fs-3"></i>
              </p>
            </div>
          </div>

          {/* Mobile Offcanvas Menu */}
          <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
            style={{ height: "100vh" }}
          >
            <div className="offcanvas-header">
              <div style={{ height: "50px" }}>
                <img
                  src={getMediaUrl(headerData?.image)}
                  onClick={() => navigate("/")}
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  style={{ height: "100%" }}
                  alt="Logo"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = require("../../Images/navlogo.png");
                  }}
                />
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <div className="col-11 m-auto">
                {/* About Us Mobile Link */}
                {aboutUsRoute && (
                  <div className="mt-2">
                    <p
                      className="fw-semibold"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate(aboutUsRoute.path);
                      }}
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    >
                      {aboutUsRoute.name}
                    </p>
                  </div>
                )}
                {disclaimerRoute && (
                  <div className="mt-2">
                    <p
                      className="fw-semibold"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate(disclaimerRoute.path);
                      }}
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    >
                      {disclaimerRoute.name}
                    </p>
                  </div>
                )}
                {/* Our Products Mobile Section */}
                {ourProductsRoute &&
                  ourProductsRoute.option &&
                  ourProductsRoute.option.length > 0 && (
                    <div className="mt-2">
                      <p
                        className="fw-semibold"
                        style={{ cursor: "pointer" }}
                        data-bs-toggle="collapse"
                        href="#ourProductsCollapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="ourProductsCollapse"
                      >
                        {ourProductsRoute.name}
                      </p>
                      <div className="collapse" id="ourProductsCollapse">
                        <div className="card card-body border-0 p-0">
                          {ourProductsRoute.option.map((product, index) => (
                            <p
                              key={index}
                              className="fw-semibold ms-3"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                navigate(product.link.replace("#", ""));
                              }}
                              data-bs-dismiss="offcanvas"
                              aria-label="Close"
                            >
                              {product.name}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                <div className="mt-2">
                  <button
                    className="buttonEffect mb-2 w-100"
                    onClick={() =>
                      window.open("https://ladderup.investwell.app", "_blank")
                    }
                  >
                    Analyse Your Portfolio
                  </button>
                </div>
                {/* Contact Button Mobile */}
                {headerData?.buttonName && (
                  <div className="mt-2">
                    <button
                      className="buttonEffect mb-3"
                      onClick={() => {
                        navigate(headerData.buttonLink.replace("#", ""));
                      }}
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    >
                      {headerData.buttonName}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
